export default __webpack_public_path__ + "static/media/Junge-mit-Hund.09ad2c86.webp";